import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { NavLink } from "react-router-dom";
import ProductionLineContent from '../../Dashboard/ProductionLineContent';
import { connect } from 'react-redux';
import { dataService } from '../../../Services/data.service';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';


export const DashboardOverviewPage = (props) => {

    const classes = useStyles();
    const [workstations, setWorkstations] = useState([])
    const { t } = useTranslation();

    useEffect((workstations) => {
        dataService.getWorkstations().then((stations) => {
            if (JSON.stringify(stations.body) !== JSON.stringify(workstations)) {
                setWorkstations(stations.body)
            }

        }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })


    }, [props.workstationState.workstationsWithScissorStatusInfo])

    return (

        <div className={classes.background}>
            <div className={classes.spacer80}>{t('ProductionLineOverview')}</div>
            <div className={classes.workstations}></div>
            {workstations.length > 0 && props.workstationState.workstationsWithScissorStatusInfo.map((workstation) => (
                <NavLink key={workstation.id} className={classes.navButton} to={`/dashboard/${workstation.id}`}>
                    <ProductionLineContent actions={props.actions} {...props} fakeDataWorkstation={workstations.find(x => x.id === workstation.id)} line={workstation} border={props.workstation.selectedWorkstation === workstation.id ? "1px solid #4654FB" : "none"}></ProductionLineContent>
                </NavLink>
            ))}
        </div>
    )
}

const useStyles = makeStyles({
    spacer80: {
        height: '50px',
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: '#000000',
        paddingLeft: "5px"
    },
    navButton: {
        textDecoration: 'none'
    },

    background: {
        padding: "20px",
        marginTop: "40px"
    },
    workstations: {
        width: 'fit-content'
    }
});

function mapStateToProps(state) {
    return {
        workstationState: state.workstationState,
    }
}

export default connect(mapStateToProps)(DashboardOverviewPage)